export default class SignUp {

    constructor(Rest) {
        this.rest = Rest.rest;
    }

    getFormData(search) {
        return this.rest.all('api/v2/auth/azure/callback').customGET("", search);
    };

    registerViaAzure(formData) {
        return this.rest.all('api/v2/auth/azure/register').post(formData);
    };

    register(formData) {
        return this.rest.all('signup')
            .post(formData, {}, {
                'Content-Type': 'application/json',
            });
    }
};

SignUp.$inject = ['Rest'];
